module.exports = __webpack_public_path__ + "static/media/Lubricants_Hydraulic_Oil_xparent_1000px.43265b31.png";